export default __webpack_public_path__ + "static/media/solucao-04.9c358c47.webp";